export class excelStyle {
  public excelStyleAlignment: excelStyleAlignment;
  public excelStyleFill: excelStyleFill;
  public excelStyleFont: excelStyleFont;
  constructor();
  constructor(fgColor?: string, alignmentH?: string, fontSz?: string, fontColour?: string, fontBold?: boolean)

  constructor(fgColor?: string, alignmentH?: string, fontSz?: string, fontColour?: string, fontBold?: boolean) {
    this.excelStyleAlignment = new excelStyleAlignment();
    this.excelStyleFill = new excelStyleFill();
    this.excelStyleFont = new excelStyleFont();
  }
}

export class excelStyleAlignment {
  public vertical: string;
  public horizontal: string;
  public wrapText: boolean;
  public textRotation: number;
  constructor() {
    this.vertical = 'bottom';
    this.horizontal = 'left';
    this.wrapText = false;
    this.textRotation = 0;
  }
}

export class excelStyleFill {
  public fgColor: excelStyleColor;
  public bgColor: excelStyleColor;
  constructor() {
    this.fgColor = new excelStyleColor('');
    this.bgColor = new excelStyleColor('');
  }
}

export class excelStyleFont {
  public bold: boolean;
  public color: excelStyleColor;
  public italic: boolean;
  public sz: string;
  constructor() {
    this.bold = false;
    this.color = new excelStyleColor('');
    this.italic = false;
    this.sz = '11';
  }
}

export class excelStyleColor {
  public rgb: string;
  constructor(rgb: string) {
    this.rgb = rgb;
  }
}
 
